import moment from 'jalali-moment';

export const formatDate = (date?: string) =>
    date ? moment.utc(date).locale('fa').local().format('YYYY/MM/DD HH:mm') : '-';

export const faNum = (value: number) => value.toLocaleString('fa-IR');

/** «۳ ساعت پیش» / «۲ روز پیش» برای ستون‌های زمانی تسک‌ها. */
export const timeAgo = (date: string) => {
    const hours = Math.max(0, Math.floor(moment().diff(moment.utc(date), 'hours', true)));
    if (hours < 1) return 'کمتر از یک ساعت پیش';
    if (hours < 48) return `${faNum(hours)} ساعت پیش`;
    return `${faNum(Math.floor(hours / 24))} روز پیش`;
};

/** پارامترهای خالی حذف می‌شوند؛ خروجی با ? شروع می‌شود یا رشته‌ی خالی است. */
export const toQuery = (params: Record<string, string | number | boolean | undefined | null>) => {
    const parts = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '' && value !== false)
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`);
    return parts.length ? `?${parts.join('&')}` : '';
};

export const percent = (part: number, total: number) =>
    total ? `${(Math.round((part / total) * 1000) / 10).toLocaleString('fa-IR')}٪` : '-';
